// extracted by mini-css-extract-plugin
export default {"notification":"Q1KlT","layout":"lOrUI","player":"LDOz5","form":"M89r9"};